import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { Request } from '../../../ts/ServerApi/requests/Request';
import { IResult } from '../../../ts/ServerApi/types/IResponse';

export interface IAccelerationNeedsScheduleParams {
  targetIds: string[];
}

export interface IAccelerationNeedsScheduleResult extends IResult {
  needsSchedule: boolean;
}

export class AccelerationNeedsScheduleRequest extends
    Request<IAccelerationNeedsScheduleParams, IAccelerationNeedsScheduleResult> {
  constructor(params: IAccelerationNeedsScheduleParams) {
    super('accelerationNeedsSchedule', params);
  }
}
